module.exports = __webpack_public_path__ + "static/media/icon-login-report-active.92938913.svg";